import React from 'react';
import { Trash2, FileText } from 'lucide-react';
import { types, fmt$, isIncomplete } from './constants';
import { BRAND } from '../kit/tokens';
import { formatDateTime } from '../kit/time';

export function RecentCalculations({ history, setDetailCalcId, del }) {
  if (history.length === 0) return null;
  return (
  <div>
    <div className="font-serif text-xl font-semibold mb-3 text-brand-navy">Recent Calculations</div>
    <div className="text-[11px] text-slate-500 mb-2">Click a row to see the documents used and the guideline reasoning behind the number.</div>
    <div className="space-y-2">
      {history.slice(0, 8).map((h) => (
        <div
          key={h.calc_id}
          className="bg-white rounded-xl border border-slate-100 p-4 flex items-center justify-between hover:border-brand-accent hover:shadow-sm transition cursor-pointer"
          data-testid={`hist-${h.calc_id}`}
          onClick={() => setDetailCalcId(h.calc_id)}
        >
          <div>
            <div className="text-sm font-semibold flex items-center gap-2 text-brand-navy">
              {
                (() => {
                  const it = h.input.income_type;
                  if (['w2_salary', 'w2_hourly', 'w2_overtime_bonus'].includes(it)) return 'W-2 Wage Earner';
                  return types.find(t => t.k === it)?.l || it;
                })()
              }
              {Array.isArray(h.documents_used) && h.documents_used.length > 0 && (
                <span className="inline-flex items-center gap-1 text-[10px] font-bold px-1.5 py-0.5 rounded" style={{ background: '#F3FAE8', color: '#3a5717' }}>
                  <FileText size={10} /> {h.documents_used.length} doc{h.documents_used.length !== 1 ? 's' : ''}
                </span>
              )}
              {h.agency_guideline && (
                <span className="text-[10px] font-bold px-1.5 py-0.5 rounded" style={{ background: '#EEF2FF', color: BRAND.navy }}>
                  {h.agency_guideline.toUpperCase()}
                </span>
              )}
            </div>
            <div className="text-xs text-slate-500">{formatDateTime(h.created_at)} — {h.method}</div>
          </div>
          <div className="flex items-center gap-4">
            {isIncomplete(h)
              ? <div className="text-sm font-bold text-amber-600" data-testid={`hist-incomplete-${h.calc_id}`}>Incomplete</div>
              : <div className="font-serif font-bold text-xl text-brand-accent">{fmt$(h.qualifying_monthly)}</div>}
            <button
              onClick={(e) => { e.stopPropagation(); del(h.calc_id); }}
              className="p-2 hover:bg-red-50 rounded-lg"
              data-testid={`hist-delete-${h.calc_id}`}
            ><Trash2 size={13} className="text-red-500" /></button>
          </div>
        </div>
      ))}
    </div>
  </div>
  );
}
